const FooterHeading = ({heading}) => {
    return (
        <h3 className="mb-3">{heading}</h3>
    );
};

export default FooterHeading;